export default {
  EVENT_ITEM_TYPE_ID: "defaultEvent",
  PERSON_ITEM_TYPE_ID: "defaultPerson",
  LOCATION_ITEM_TYPE_ID: "defaultLocation",
  NARRATIVE_FOLDER_TYPE_ID: "defaultNarrative",
  EXPOSITION_ITEM_TYPE_ID: "defaultExposition",
  MINDMAP_NODE_TYPE_ID: "genericNode"
};
